import {Fragment} from 'react';

import {CurrencyService as Service} from './CurrencyService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useImExExcel} from '../../../shared/hooks/ImExExcel';

export const List = () => {

  const header = 'Tiền tệ';
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'code', header: 'Mã tiền tệ', width: 160},
      {field: 'name', header: 'Tên tiền tệ', minWidth: 200},
      {field: 'rate', header: 'Tỷ giá', width: 140, dataType: 'number'},
      {field: 'formatQuantity', header: 'Thập phân số lượng', width: 180, dataType: 'number'},
      {field: 'formatPrice', header: 'Thập phân đơn giá', width: 180, dataType: 'number'},
      {field: 'formatTotal', header: 'Thập phân tổng tiền', width: 180, dataType: 'number'},
      // {field: 'formatTaxDetail', header: 'Thuế chi tiết', width: 180, dataType: 'number'},
      {field: 'formatTaxAmount', header: 'Thập phân trọng lượng', width: 180, dataType: 'number'},
      {field: 'readCurrency', header: 'Đọc tiền tệ', width: 180},
      {field: 'readDecimal', header: 'Đọc thập phân', width: 180}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'code', header: 'Mã tiền tệ', required: true, uppercase: true, InputTextProps: {maxLength: 3}, className: 'md:col-4'},
      {field: 'name', header: 'Tên tiền tệ', required: true, InputTextProps: {maxLength: 50}, className: 'md:col-8'},
      {field: 'rate', header: 'Tỷ giá', required: true, type: 'InputNumber', InputNumberProps: {min: 0, max: 99999, maxFractionDigits: 2}, className: 'md:col-6'},
      {field: 'formatQuantity', header: 'Thập phân số lượng', required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'formatPrice', header: 'Thập phân đơn giá', required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'formatTotal', header: 'Thập phân tổng tiền', required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      // {field: 'formatTaxDetail', header: 'Thuế chi tiết', required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'formatTaxAmount', header: 'Thập phân trọng lượng', required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'readCurrency', header: 'Đọc tiền tệ', InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'readDecimal', header: 'Đọc thập phân', InputTextProps: {maxLength: 500}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderImExExcel, download, showImportDialog} = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-tien-te',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderImExExcel()}
    </Fragment>
  )
}
